import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "edit-police pt-0" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "edit-police__head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "edit-police__head__title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Consistencia de datos")
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  class: "text-center text-main"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin d-block mb-1" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "edit-police__body"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("b", null, "GENERAL")
], -1)
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Total de pólizas:", -1)
const _hoisted_15 = { class: "col-md-5" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Total de clientes:", -1)
const _hoisted_18 = { class: "col-md-5" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Prima mensual promedio:", -1)
const _hoisted_21 = { class: "col-md-5" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Edad promedio:", -1)
const _hoisted_24 = { class: "col-md-5" }
const _hoisted_25 = {
  key: 1,
  class: "card mb-3"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("b", null, "ESTADO DE PAGOS")
], -1)
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "row mb-3" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Al día", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1 prima pendiente", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2 primas pendientes", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "3 o más", -1)
const _hoisted_35 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "# Clientes", -1)
const _hoisted_42 = { class: "col-md-5" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "# Polizas", -1)
const _hoisted_45 = { class: "col-md-5" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Edad promedio", -1)
const _hoisted_48 = { class: "col-md-5" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Prima mensual promedio", -1)
const _hoisted_51 = { class: "col-md-5" }
const _hoisted_52 = {
  key: 2,
  class: "card mb-3"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("b", null, "RECAUDACIÓN")
], -1)
const _hoisted_54 = { class: "card-body" }
const _hoisted_55 = { class: "row mb-3" }
const _hoisted_56 = { class: "col-md-4" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Año", -1)
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Mes", -1)
const _hoisted_63 = ["value"]
const _hoisted_64 = { class: "col-md-2" }
const _hoisted_65 = { class: "form-group" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { class: "row" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Recaudación estimada", -1)
const _hoisted_70 = { class: "col-md-5" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, " Cantidad de pólizas con promoción devolución ", -1)
const _hoisted_73 = { class: "col-md-5" }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Monto de devolución", -1)
const _hoisted_76 = { class: "col-md-5" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, "Recaudación real", -1)
const _hoisted_79 = { class: "col-md-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.flags.searching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" Cargando datos... ")
            ]))
          : _createCommentVNode("", true),
        (!_ctx.flags.searching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.data)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.data.totalPolicies), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.data.totalClients), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, " S/ " + _toDisplayString(this.formatNumber(_ctx.data.averagePaymentAmount)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.data.averageUserAge), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _withDirectives(_createElementVNode("select", {
                                  name: "",
                                  id: "",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pendingPayments) = $event)),
                                  style: {"height":"37px"}
                                }, _hoisted_35, 512), [
                                  [_vModelSelect, _ctx.pendingPayments]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("button", {
                                  class: "btn btn-main",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.init()))
                                }, _hoisted_39)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.data.totalFilteredClients), 1)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.data.totalFilteredPolicies), 1)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _hoisted_47,
                            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.data.averageFilteredUserAge), 1)
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _createElementVNode("div", _hoisted_51, " S/ " + _toDisplayString(this.formatNumber(_ctx.data.averageFilteredPaymentAmount)), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.collection)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _withDirectives(_createElementVNode("select", {
                                  name: "",
                                  id: "",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.year) = $event)),
                                  style: {"height":"37px"}
                                }, [
                                  _hoisted_58,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item,
                                      key: item
                                    }, _toDisplayString(item), 9, _hoisted_59))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.year]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _withDirectives(_createElementVNode("select", {
                                  name: "",
                                  id: "",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.month) = $event)),
                                  style: {"height":"37px"}
                                }, [
                                  _hoisted_62,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item,
                                      key: item
                                    }, _toDisplayString(item), 9, _hoisted_63))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.month]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("button", {
                                  class: "btn btn-main",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getCollection()))
                                }, _hoisted_67)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_68, [
                            _hoisted_69,
                            _createElementVNode("div", _hoisted_70, " S/ " + _toDisplayString(this.formatNumber(_ctx.collection.estimatedAmount)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _hoisted_72,
                            _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.collection.promotionPolicies), 1)
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _hoisted_75,
                            _createElementVNode("div", _hoisted_76, " S/ " + _toDisplayString(this.formatNumber(_ctx.collection.promotionPoliciesAmount)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            _hoisted_78,
                            _createElementVNode("div", _hoisted_79, " S/ " + _toDisplayString(this.formatNumber(_ctx.collection.realAmount)), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}